import script from "./CounterHomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CounterHomeView.vue?vue&type=script&setup=true&lang=ts"

import "./CounterHomeView.vue?vue&type=style&index=0&id=c5c33dd4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c33dd4"]])

export default __exports__